import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { Suspense } from "react";
import { z } from "zod";
import { secretsQueryOptions } from "@/app/secrets/api/get-secrets";
import { SecretsListSkeleton } from "@/app/secrets/components/secrets-list-skeleton";
import { SecretList } from "@/app/secrets/list/list";
import { nameFilterSchema } from "@/components/custom/filters/name-filter";
import {
  scopeFilterSearchDefaults,
  scopeFilterSearchSchema,
} from "@/components/custom/resources/scope-filter";

const secretTypeSchema = z.enum(["list", "new"]);

const secretsSearchSchema = z.object({
  type: secretTypeSchema.catch("list").default("list"),
  newKey: z.string().optional().catch("").default(""),
  ...nameFilterSchema.shape,
  ...scopeFilterSearchSchema.shape,
});

const defaultValues = {
  type: "list" as const,
  newKey: "",
  name: "",
  ...scopeFilterSearchDefaults,
};

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/"
)({
  validateSearch: secretsSearchSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
  loader: ({ context: { queryClient }, params }) => {
    queryClient.prefetchQuery(
      secretsQueryOptions({ binding: "project", scope: params })
    );
  },
  component: () => (
    <Suspense fallback={<SecretsListSkeleton />}>
      <SecretList />
    </Suspense>
  ),
});
